module.exports = __webpack_public_path__ + "img/clipboard.b765d3a6.svg";